export default __webpack_public_path__ + "static/img-art-pandas-profiling-5-382853e9409f3b5e0c060f7e25705aa8.webp";